import { render, staticRenderFns } from "./CarQeue.vue?vue&type=template&id=2d0925af&scoped=true"
import script from "./CarQeue.vue?vue&type=script&lang=js"
export * from "./CarQeue.vue?vue&type=script&lang=js"
import style0 from "./CarQeue.vue?vue&type=style&index=0&id=2d0925af&prod&scoped=true&lang=less"
import style1 from "./CarQeue.vue?vue&type=style&index=1&id=2d0925af&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0925af",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VCard,VCardText,VDataTable,VDivider,VIcon,VLayout,VSelect,VSpacer,VTab,VTabItem,VTabs})
